/**
 * @desc 导出报关箱单记录
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(tmsNo: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/exportTrackBgxReport/${tmsNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
